import {
  FILTER_AMOUNT_DOWN,
  FILTER_AMOUNT_UP,
  FILTER_CLIENT_BY_INSTRUMENT_NAME,
  FILTER_CLIENT_NAME,
  FILTER_ROLE,
  FILTER_CURRENCY_NAME,
  FILTER_DATE_FROM,
  FILTER_DATE_TO,
  FILTER_INSTRUMENT_NAME,
  FILTER_MARKET_NAME,
  FILTER_ORDER_TYPE,
  FILTER_PORTFOLIO_DETAIL,
  FILTER_SEARCH_ALL,
  ORDER_CLIENTS,
  SORT_ORDERS,
  TRADER_DIARY_TABLE,
  FILTER_CLIENT_INVESTMENT_HORIZONTE,
  FILTER_CLIENT_RISK_PROFILE,
  FILTER_CLIENT_SKILL_EXPERIENCE,
  FILTER_CLIENT_PREFERENCE,
  FILTER_CLIENT_LOSS_ABILITY,
  FILTER_CLIENT_SUITABILITY,
  FILTER_INSTRUMENT_ISIN,
  FILTER_INSTRUMENT_CURRENCY,
  FILTER_INSTRUMENT_TICKER,
  FILTER_INSTRUMENT_ASSET_CLASS,
  FILTER_INSTRUMENT_CATEGORY,
  FILTER_INSTRUMENT_EXPERIENCE,
  FILTER_INSTRUMENT_PREFERENCE,
  FILTER_INSTRUMENT_LOSS_ABILITY,
  FILTER_INSTRUMENT_RISK,
  FILTER_INSTRUMENT_HORIZONTE,
} from '../actionTypes'
import { ClientSortOptions, OrdersByStateOptions, TraderDiaryByStateOptions } from '../reducers/filters'

export const filterClientName = (searchedClientName: string) => ({
  type: FILTER_CLIENT_NAME,
  payload: searchedClientName,
})

export const filterRole = (searchedRole: string) => ({
  type: FILTER_ROLE,
  payload: searchedRole,
})

export const filterDateFrom = (searchedDateFrom: Date) => ({
  type: FILTER_DATE_FROM,
  payload: searchedDateFrom,
})

export const filterDateTo = (searchedDateTo: Date) => ({
  type: FILTER_DATE_TO,
  payload: searchedDateTo,
})

export const sortClients = (value: string) => ({
  type: ORDER_CLIENTS,
  payload: value,
})

export const filterPortfolioDetail = (name: string, value: boolean) => ({
  type: FILTER_PORTFOLIO_DETAIL,
  payload: { name, value },
})

export const filterInstrumentName = (searchedInstrumentName: string) => ({
  type: FILTER_INSTRUMENT_NAME,
  payload: searchedInstrumentName,
})

export const filterMarketName = (searchedMarketName: string) => ({
  type: FILTER_MARKET_NAME,
  payload: searchedMarketName,
})

export const searchAllName = (searchAll: boolean) => ({
  type: FILTER_SEARCH_ALL,
  payload: searchAll,
})

export const filterClientAmountUp = (searchedAmountUp: string) => ({
  type: FILTER_AMOUNT_UP,
  payload: searchedAmountUp,
})

export const filterClientAmountDown = (searchedAmountDown: string) => ({
  type: FILTER_AMOUNT_DOWN,
  payload: searchedAmountDown,
})

export const filterClientByInstrumentName = (searchedClientByInstrumentName: string) => ({
  type: FILTER_CLIENT_BY_INSTRUMENT_NAME,
  payload: searchedClientByInstrumentName,
})

export const sortOrderTable = (value: OrdersByStateOptions) => ({ type: SORT_ORDERS, payload: value })

export const filterCurrencyName = (searchedCurrencyName: string) => ({
  type: FILTER_CURRENCY_NAME,
  payload: searchedCurrencyName,
})

export const filterOrderType = (searchedOrderType: string) => ({
  type: FILTER_ORDER_TYPE,
  payload: searchedOrderType,
})

export const sortTradeDiaryTable = (value: TraderDiaryByStateOptions) => ({ type: TRADER_DIARY_TABLE, payload: value })

export const filterClientInvestmentHorizonte = (value: string) => ({
  type: FILTER_CLIENT_INVESTMENT_HORIZONTE,
  payload: value,
})

export const filterClientRiskProfile = (value: string) => ({
  type: FILTER_CLIENT_RISK_PROFILE,
  payload: value,
})

export const filterClientSkillAndExperience = (value: string) => ({
  type: FILTER_CLIENT_SKILL_EXPERIENCE,
  payload: value,
})

export const filterClientPreference = (value: string) => ({
  type: FILTER_CLIENT_PREFERENCE,
  payload: value,
})

export const filterClientLossAbility = (value: string) => ({
  type: FILTER_CLIENT_LOSS_ABILITY,
  payload: value,
})

export const filterClientSuitability = (value: string) => ({
  type: FILTER_CLIENT_SUITABILITY,
  payload: value,
})

export const filterInstrumentIsin = (value: string) => ({
  type: FILTER_INSTRUMENT_ISIN,
  payload: value,
})

export const filterInstrumentCurrency = (value: string) => ({
  type: FILTER_INSTRUMENT_CURRENCY,
  payload: value,
})

export const filterInstrumentTicker = (value: string) => ({
  type: FILTER_INSTRUMENT_TICKER,
  payload: value,
})

export const filterInstrumentAssetClass = (value: string) => ({
  type: FILTER_INSTRUMENT_ASSET_CLASS,
  payload: value,
})

export const filterInstrumentCategory = (value: string) => ({
  type: FILTER_INSTRUMENT_CATEGORY,
  payload: value,
})

export const filterInstrumentExperience = (value: string) => ({
  type: FILTER_INSTRUMENT_EXPERIENCE,
  payload: value,
})

export const filterInstrumentPreference = (value: string) => ({
  type: FILTER_INSTRUMENT_PREFERENCE,
  payload: value,
})

export const filterInstrumentLossAbility = (value: string) => ({
  type: FILTER_INSTRUMENT_LOSS_ABILITY,
  payload: value,
})

export const filterInstrumentRisk = (value: string) => ({
  type: FILTER_INSTRUMENT_RISK,
  payload: value,
})

export const filterInstrumentHorizonte = (value: string) => ({
  type: FILTER_INSTRUMENT_HORIZONTE,
  payload: value,
})